// pages/Dashboard/UserRequestsData.js
import React, { useEffect, useState, useMemo, useRef } from "react";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Modal,
  Button,
  Spinner,
  Badge,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import CONFIG from "../../config";
import ProductAdd from "./Productadd"; // ✅ Add Product modal

/**
 * Premium Requests page
 * - Shows Swap ID column
 * - Newest first (createdAt desc -> id desc)
 * - Auto-refresh every 15s + manual Refresh button
 * - Displays logged-in user email in header
 */

const PAGE_SIZE = 10;
const AUTO_REFRESH_MS = 15000; // 15 seconds

// 🔹 All custom styles here – change widths/colors easily
const styles = {
  pageContainer: {
    background: "linear-gradient(180deg, #F6F9FC 0%, #eef3f9 100%)",
    minHeight: "100vh",
    paddingTop: "3rem",
    paddingBottom: "3rem",
  },

  // Outer wrapper of the page (inside Container)
  premiumWrap: {
    fontFamily:
      'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial',
    color: "#20232a",
    maxWidth: 1866,
    margin: "auto",
    marginTop: "-30px",
    padding: 10,
  },

  // Header / hero
  headerHero: {
    maxWidth: 1300,
    margin: "auto",
    display: "flex",
    justifyContent: "space-between",
    gap: 20,
    alignItems: "flex-start",
    marginBottom: 24,
  },
  headerHeroMobile: {
    flexDirection: "column",
    alignItems: "stretch",
  },
  heroLeft: {
    flex: 1,
  },
  heroTitle: {
    margin: 0,
    fontSize: 28,
    letterSpacing: "-0.2px",
    maxWidth: 600,
  },
  heroSub: {
    margin: "6px 0 0",
    color: "#6b7280",
    maxWidth: 600,
  },
  heroRight: {
    width: 380,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: 8,
  },
  heroRightMobile: {
    width: "100%",
    alignItems: "stretch",
  },

  stats: {
    display: "flex",
    gap: 12,
    marginTop: 6,
  },
  stat: {
    background:
      "linear-gradient(180deg, rgba(255,255,255,0.9), rgba(250,250,250,0.7))",
    padding: "10px 14px",
    borderRadius: 10,
    boxShadow: "0 4px 18px rgba(16,24,40,0.06)",
    textAlign: "center",
    minWidth: 72,
  },
  statValue: {
    fontWeight: 700,
    fontSize: 18,
  },
  statLabel: {
    color: "#6b7280",
    fontSize: 12,
    marginTop: 2,
  },

  // TABLE CONTAINER – controls width + centering
  tableContainer: {
    maxWidth: "1300px", // 👈 NEED chhota / bada yahin change karo
    margin: "0 auto 32px auto",
  },

  // Orange header (top bar)
  orangeHeader: {
    width: "calc(100% + 20px)", // full bleed against walls
    marginLeft: "-10px",
    marginRight: "-10px",
    marginTop: "-10px",
    marginBottom: "20px",
    padding: "30px",
    background: "#FF7F50",
    color: "white",
    borderRadius: "15px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  orangeHeaderLeftBtns: {
    display: "flex",
    gap: "15px",
  },
  orangeHeaderMyAccount: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    color: "white",
  },
  orangeHeaderAvatar: {
    fontSize: "26px",
    backgroundColor: "white",
    color: "#4b0082",
    width: "45px",
    height: "45px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
  },
  orangeHeaderAccountText: {
    fontSize: "18px",
    fontWeight: "700",
    color: "#702963",
  },

  // Cards / tables
  glassCard: {
    borderRadius: 12,
    overflow: "hidden",
    border: "1px solid rgba(19,24,41,0.04)",
    background:
      "linear-gradient(180deg, rgba(255,255,255,0.85), rgba(250,250,250,0.75))",
    boxShadow: "0 6px 30px rgba(11,15,35,0.06)",
  },
  cardTop: {
    borderBottom: "1px solid rgba(16,24,40,0.04)",
    padding: "0.75rem 1.5rem",
  },
  countPill: {
    fontWeight: 700,
    padding: "8px 12px",
    borderRadius: 20,
  },

  tableWrap: {
    maxHeight: 520,
    overflow: "auto",
  },

  premiumTable: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "0 8px",
    minWidth: "100%",
  },
  tableHeadCell: {
    background: "transparent",
    color: "#374151",
    fontWeight: 600,
    borderBottom: 0,
    padding: "12px 18px",
    whiteSpace: "nowrap",
  },
  tableRowBase: {
    background: "linear-gradient(180deg, #fff, #fff)",
    borderRadius: 10,
    cursor: "pointer",
    transition: "transform 0.15s ease, box-shadow 0.15s ease",
  },
  tableRowHover: {
    transform: "translateY(-4px)",
    boxShadow: "0 10px 30px rgba(16,24,40,0.06)",
  },
  tableCell: {
    verticalAlign: "middle",
    padding: "12px 18px",
    borderTop: 0,
    borderBottom: 0,
    whiteSpace: "nowrap",
  },

  paginationInfo: {
    color: "#6c757d",
    fontSize: 12,
  },
  paginationControls: {
    display: "flex",
    alignItems: "center",
  },

  pillBase: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "6px 10px",
    borderRadius: 999,
    fontWeight: 600,
    fontSize: 12,
  },
  pillPending: {
    background: "#fff3cd",
    color: "#856404",
    border: "1px solid rgba(133,100,4,0.08)",
  },
  pillAccepted: {
    background: "linear-gradient(90deg,#bbf7d0,#86efac)",
    color: "#065f46",
    border: "1px solid rgba(6,95,70,0.06)",
  },
  pillRejected: {
    background: "linear-gradient(90deg,#fecaca,#fda4af)",
    color: "#7f1d1d",
    border: "1px solid rgba(127,29,29,0.06)",
  },
};

// ================= helpers for data =================
function getCurrentUserEmail() {
  const raw = localStorage.getItem("user");
  if (!raw) return "";
  try {
    if (raw.trim().startsWith("{") || raw.trim().startsWith("[")) {
      const obj = JSON.parse(raw);
      return (obj.email || obj.user_email || obj.username || obj.user || "")
        .toString()
        .toLowerCase();
    }
    return raw.toString().toLowerCase();
  } catch {
    return raw.toString().toLowerCase();
  }
}

function normalizeRow(row) {
  const r = row || {};
  const get = (o, ...keys) => {
    for (const k of keys) {
      if (!o) continue;
      if (Object.prototype.hasOwnProperty.call(o, k) && o[k] != null) return o[k];
    }
    return undefined;
  };

  const requestUserEmail =
    get(
      r,
      "request_user_email",
      "requestUserEmail",
      "requester_email",
      "requesterEmail",
      "sender_email",
      "email",
      "user_email"
    ) || "";

  const productOwnerEmail =
    get(
      r,
      "product_owner_email",
      "productOwnerEmail",
      "owner_email",
      "ownerEmail",
      "to_email"
    ) || "";

  const requestUserProductName =
    get(
      r,
      "request_user_product_name",
      "requestUserProductName",
      "request_user_product",
      "requestUserProduct",
      "request_user_product_name"
    ) || "";

  const requestedProductName =
    get(
      r,
      "requested_product_name",
      "requestedProductName",
      "requested_product",
      "requestedProduct"
    ) || "";

  const id =
    get(r, "id", "_id", "request_id", "swap_id") ||
    Math.random().toString(36).slice(2, 9);
  const status = (get(r, "status") || "").toString();
  const message = get(r, "message", "note", "comment", "body") || "";
  const createdAt =
    get(r, "created_at", "createdAt", "created", "timestamp") || null;

  return {
    raw: r,
    id,
    requestUserEmail: (requestUserEmail || "").toString(),
    productOwnerEmail: (productOwnerEmail || "").toString(),
    requestUserProductName: requestUserProductName.toString(),
    requestedProductName: requestedProductName.toString(),
    status,
    message,
    createdAt,
  };
}

function sortNewestFirst(arr) {
  return arr.slice().sort((a, b) => {
    const aTime = a.createdAt ? Date.parse(a.createdAt) : NaN;
    const bTime = b.createdAt ? Date.parse(b.createdAt) : NaN;
    if (!Number.isNaN(aTime) && !Number.isNaN(bTime)) return bTime - aTime;
    if (!Number.isNaN(aTime)) return -1;
    if (!Number.isNaN(bTime)) return 1;
    const ai = Number(a.id) || 0;
    const bi = Number(b.id) || 0;
    return bi - ai;
  });
}

// ================= main component =================
export default function UserRequestsData() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  const [pageSent, setPageSent] = useState(1);
  const [pageReceived, setPageReceived] = useState(1);

  const [showAddModal, setShowAddModal] = useState(false);

  const currentUser = getCurrentUserEmail();
  const rawUser = localStorage.getItem("user");
  const intervalRef = useRef(null);

  const [isMobile, setIsMobile] = useState(false);
  const [hoveredRowId, setHoveredRowId] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      if (typeof window !== "undefined") {
        setIsMobile(window.innerWidth < 992);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      navigate("/login");
      return;
    }
    fetchRows();

    intervalRef.current = setInterval(() => {
      fetchRows({ silent: true });
    }, AUTO_REFRESH_MS);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
    // eslint-disable-next-line
  }, []);

  async function fetchRows({ silent = false } = {}) {
    if (!silent) {
      setLoading(true);
      setError(null);
    }

    const base = (CONFIG?.API_BASE || window.APP_CONFIG?.API_URL || "").replace(
      /\/$/,
      ""
    );
    const urls = [`${base}/swap-requests`, `${base}/api/swap-requests`];

    let lastErr = null;
    for (const url of urls) {
      try {
        const res = await axios.get(url);
        const data = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.data)
          ? res.data.data
          : [];
        const normalized = data.map(normalizeRow);
        const sorted = sortNewestFirst(normalized);
        setRows(sorted);
        if (!silent) setLoading(false);
        return;
      } catch (err) {
        lastErr = err;
      }
    }

    if (!silent) {
      setLoading(false);
      setError(
        lastErr?.response?.data?.message ||
          lastErr?.message ||
          "Failed to fetch requests"
      );
    }
  }

  const sent = useMemo(
    () =>
      rows.filter(
        (r) => (r.requestUserEmail || "").toLowerCase() === currentUser
      ),
    [rows, currentUser]
  );
  const received = useMemo(
    () =>
      rows.filter(
        (r) => (r.productOwnerEmail || "").toLowerCase() === currentUser
      ),
    [rows, currentUser]
  );

  const filteredSent = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return sent;
    return sent.filter((r) =>
      `${r.id} ${r.requestUserProductName} ${r.requestedProductName} ${r.message} ${r.status}`
        .toLowerCase()
        .includes(q)
    );
  }, [sent, search]);

  const filteredReceived = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return received;
    return received.filter((r) =>
      `${r.id} ${r.requestUserProductName} ${r.requestedProductName} ${r.message} ${r.status}`
        .toLowerCase()
        .includes(q)
    );
  }, [received, search]);

  const pagedSent = filteredSent.slice(
    (pageSent - 1) * PAGE_SIZE,
    pageSent * PAGE_SIZE
  );
  const pagedReceived = filteredReceived.slice(
    (pageReceived - 1) * PAGE_SIZE,
    pageReceived * PAGE_SIZE
  );

  function openModal(row) {
    setSelected(row);
    setModalVisible(true);
  }
  function closeModal() {
    setSelected(null);
    setModalVisible(false);
  }

  function formatDateLocal(iso) {
    if (!iso) return "-";
    try {
      return new Date(iso).toLocaleString();
    } catch {
      return iso;
    }
  }

  return (
    <>
      <Container fluid className="py-5" style={styles.pageContainer}>
        <div className="premium-wrap" style={styles.premiumWrap}>
          {/* 🔶 ORANGE HEADER – full width */}
          <div style={styles.orangeHeader}>
            {/* LEFT SIDE BUTTONS */}
            <div style={styles.orangeHeaderLeftBtns}>
              <Button
                style={{
                  backgroundColor: "#702963",
                  borderColor: "#702963",
                }}
                onClick={() => navigate("/requests")}
              >
                Requests Data
              </Button>

              <Button
                style={{
                  backgroundColor: "#702963",
                  borderColor: "#702963",
                }}
                onClick={() => setShowAddModal(true)}
              >
                Add Product
              </Button>
            </div>

            {/* RIGHT SIDE – MY ACCOUNT */}
            <div
              style={styles.orangeHeaderMyAccount}
              onClick={() => navigate("/myaccount")}
            >
              <div style={styles.orangeHeaderAvatar}>👤</div>

              <span style={styles.orangeHeaderAccountText}>My Account</span>
            </div>
          </div>

          {/* Header */}
          <div
            className="header-hero mb-4"
            style={{
              ...styles.headerHero,
              ...(isMobile ? styles.headerHeroMobile : {}),
            }}
          >
            <div className="hero-left" style={styles.heroLeft}>
              <h1 className="hero-title" style={styles.heroTitle}>
                Requests Dashboard
              </h1>
              <p className="hero-sub" style={styles.heroSub}>
                Click any row to view details.
              </p>

              {/* logged in user */}
              <div style={{ marginTop: 8 }}>
                <small className="text-muted">Logged in as: </small>
                {currentUser ? (
                  <a
                    href={`mailto:${currentUser}`}
                    style={{
                      color: "#374151",
                      fontWeight: 600,
                      marginLeft: 6,
                    }}
                  >
                    {currentUser}
                  </a>
                ) : (
                  <span className="text-muted" style={{ marginLeft: 6 }}>
                    —
                  </span>
                )}
              </div>
            </div>

            <div
              className="hero-right"
              style={{
                ...styles.heroRight,
                ...(isMobile ? styles.heroRightMobile : {}),
              }}
            >
              <div className="stats mt-3" style={styles.stats}>
                <div className="stat" style={styles.stat}>
                  <div className="stat-value" style={styles.statValue}>
                    {filteredSent.length}
                  </div>
                  <div className="stat-label" style={styles.statLabel}>
                    Sent
                  </div>
                </div>
                <div className="stat" style={styles.stat}>
                  <div className="stat-value" style={styles.statValue}>
                    {filteredReceived.length}
                  </div>
                  <div className="stat-label" style={styles.statLabel}>
                    Received
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* SENT TABLE */}
          <div style={styles.tableContainer}>
            <Card className="glass-card mb-4" style={styles.glassCard}>
              <Card.Body className="p-0">
                <div
                  className="card-top d-flex align-items-center justify-content-between px-4 py-3"
                  style={styles.cardTop}
                >
                  <div>
                    <h5 className="mb-0">Requested Products (Sent)</h5>
                    <small className="text-muted">
                      Requests created by you
                    </small>
                  </div>
                  <Badge
                    bg="dark"
                    pill
                    className="count-pill"
                    style={styles.countPill}
                  >
                    {filteredSent.length}
                  </Badge>
                </div>

                <div className="table-wrap" style={styles.tableWrap}>
                  {loading ? (
                    <div className="py-5 text-center">
                      <Spinner animation="border" />
                    </div>
                  ) : filteredSent.length === 0 ? (
                    <div className="p-4 text-center text-muted">
                      No sent requests found
                    </div>
                  ) : (
                    <div style={{ overflowX: "auto" }}>
                      <Table
                        responsive
                        hover
                        className="mb-0 premium-table"
                        style={styles.premiumTable}
                      >
                        <thead className="table-head">
                          <tr>
                            <th style={styles.tableHeadCell}>No.</th>
                            <th style={styles.tableHeadCell}>Swap ID</th>
                            <th
                              style={styles.tableHeadCell}
                              className="min-w-200"
                            >
                              Your Product
                            </th>
                            <th
                              style={styles.tableHeadCell}
                              className="min-w-200"
                            >
                              Requested For
                            </th>
                            <th style={styles.tableHeadCell}>To</th>
                            <th style={styles.tableHeadCell}>Status</th>
                            <th style={styles.tableHeadCell}>When</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pagedSent.map((r, i) => (
                            <tr
                              key={r.id}
                              className="clickable-row"
                              onClick={() => openModal(r)}
                              onMouseEnter={() => setHoveredRowId(r.id)}
                              onMouseLeave={() => setHoveredRowId(null)}
                              style={{
                                ...styles.tableRowBase,
                                ...(hoveredRowId === r.id
                                  ? styles.tableRowHover
                                  : {}),
                              }}
                            >
                              <td style={styles.tableCell}>
                                {(pageSent - 1) * PAGE_SIZE + i + 1}
                              </td>
                              <td style={styles.tableCell} className="fw-bold">
                                {r.id}
                              </td>
                              <td style={styles.tableCell}>
                                <div className="fw-semibold">
                                  {r.requestUserProductName}
                                </div>
                                <div className="text-muted small">by you</div>
                              </td>
                              <td style={styles.tableCell}>
                                {r.requestedProductName}
                              </td>
                              <td style={styles.tableCell}>
                                {r.productOwnerEmail || "—"}
                              </td>
                              <td style={styles.tableCell}>
                                <StatusPill status={r.status} />
                              </td>
                              <td style={styles.tableCell}>
                                {formatDateLocal(r.createdAt)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </div>

                <div className="px-3 py-2 d-flex justify-content-between align-items-center">
                  <div style={styles.paginationInfo}>
                    Total: {filteredSent.length}
                  </div>
                  <div
                    className="pagination-controls"
                    style={styles.paginationControls}
                  >
                    <Button
                      size="sm"
                      variant="light"
                      disabled={pageSent <= 1}
                      onClick={() => setPageSent(pageSent - 1)}
                    >
                      Prev
                    </Button>
                    <span className="mx-2">{pageSent}</span>
                    <Button
                      size="sm"
                      variant="light"
                      disabled={pageSent * PAGE_SIZE >= filteredSent.length}
                      onClick={() => setPageSent(pageSent + 1)}
                    >
                      Next
                    </Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>

          {/* RECEIVED TABLE */}
          <div style={styles.tableContainer}>
            <Card className="glass-card mb-4" style={styles.glassCard}>
              <Card.Body className="p-0">
                <div
                  className="card-top d-flex align-items-center justify-content-between px-4 py-3"
                  style={styles.cardTop}
                >
                  <div>
                    <h5 className="mb-0">Requests Received</h5>
                    <small className="text-muted">
                      Requests sent to you (product owner)
                    </small>
                  </div>
                  <Badge
                    bg="dark"
                    pill
                    className="count-pill"
                    style={styles.countPill}
                  >
                    {filteredReceived.length}
                  </Badge>
                </div>

                <div className="table-wrap" style={styles.tableWrap}>
                  {loading ? (
                    <div className="py-5 text-center">
                      <Spinner animation="border" />
                    </div>
                  ) : filteredReceived.length === 0 ? (
                    <div className="p-4 text-center text-muted">
                      No received requests found
                    </div>
                  ) : (
                    <div style={{ overflowX: "auto" }}>
                      <Table
                        responsive
                        hover
                        className="mb-0 premium-table"
                        style={styles.premiumTable}
                      >
                        <thead className="table-head">
                          <tr>
                            <th style={styles.tableHeadCell}>#</th>
                            <th style={styles.tableHeadCell}>Swap ID</th>
                            <th
                              style={styles.tableHeadCell}
                              className="min-w-200"
                            >
                              Sender&apos;s Product
                            </th>
                            <th
                              style={styles.tableHeadCell}
                              className="min-w-200"
                            >
                              Requested For
                            </th>
                            <th style={styles.tableHeadCell}>From</th>
                            <th style={styles.tableHeadCell}>Status</th>
                            <th style={styles.tableHeadCell}>When</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pagedReceived.map((r, i) => (
                            <tr
                              key={r.id}
                              className="clickable-row"
                              onClick={() => openModal(r)}
                              onMouseEnter={() => setHoveredRowId(r.id)}
                              onMouseLeave={() => setHoveredRowId(null)}
                              style={{
                                ...styles.tableRowBase,
                                ...(hoveredRowId === r.id
                                  ? styles.tableRowHover
                                  : {}),
                              }}
                            >
                              <td style={styles.tableCell}>
                                {(pageReceived - 1) * PAGE_SIZE + i + 1}
                              </td>
                              <td style={styles.tableCell} className="fw-bold">
                                {r.id}
                              </td>
                              <td style={styles.tableCell}>
                                <div className="fw-semibold">
                                  {r.requestUserProductName}
                                </div>
                                <div className="text-muted small">sender</div>
                              </td>
                              <td style={styles.tableCell}>
                                {r.requestedProductName}
                              </td>
                              <td style={styles.tableCell}>
                                {r.requestUserEmail || "—"}
                              </td>
                              <td style={styles.tableCell}>
                                <StatusPill status={r.status} />
                              </td>
                              <td style={styles.tableCell}>
                                {formatDateLocal(r.createdAt)}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </div>

                <div className="px-3 py-2 d-flex justify-content-between align-items-center">
                  <div style={styles.paginationInfo}>
                    Total: {filteredReceived.length}
                  </div>
                  <div
                    className="pagination-controls"
                    style={styles.paginationControls}
                  >
                    <Button
                      size="sm"
                      variant="light"
                      disabled={pageReceived <= 1}
                      onClick={() => setPageReceived(pageReceived - 1)}
                    >
                      Prev
                    </Button>
                    <span className="mx-2">{pageReceived}</span>
                    <Button
                      size="sm"
                      variant="light"
                      disabled={
                        pageReceived * PAGE_SIZE >= filteredReceived.length
                      }
                      onClick={() => setPageReceived(pageReceived + 1)}
                    >
                      Next
                    </Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </Container>

      {/* Product Add Modal – same as Dashboard */}
      <ProductAdd
        show={showAddModal}
        handleClose={() => setShowAddModal(false)}
        userEmail={rawUser}
        onProductAdded={() => {
          // optional: refetch products or show toast
        }}
      />

      {/* Modal for Request details */}
      <Modal show={modalVisible} onHide={closeModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Request Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selected ? (
            <Row>
              <Col md={8}>
                <h5 className="mb-2">
                  {selected.requestUserProductName} →{" "}
                  {selected.requestedProductName}
                </h5>
                <div className="text-muted small mb-3">
                  ID: <strong>{selected.id}</strong>
                </div>

                <p>
                  <strong>Message</strong>
                </p>
                <p className="text-muted">{selected.message || "-"}</p>

                <p className="mb-1">
                  <strong>From</strong>
                </p>
                <div className="text-muted small mb-2">
                  {selected.requestUserEmail || "-"}
                </div>

                <p className="mb-1">
                  <strong>To</strong>
                </p>
                <div className="text-muted small mb-2">
                  {selected.productOwnerEmail || "-"}
                </div>

                <p className="mb-1">
                  <strong>Status</strong>
                </p>
                <StatusPill status={selected.status} />
              </Col>

              <Col md={4}>
                <Card className="mb-3">
                  <Card.Body>
                    <div className="text-muted small">Requested at</div>
                    <div className="fw-bold">
                      {formatDateLocal(selected.createdAt)}
                    </div>
                  </Card.Body>
                </Card>

                <div className="d-grid gap-2">
                  <Button variant="secondary" onClick={closeModal}>
                    Close
                  </Button>
                </div>
              </Col>
            </Row>
          ) : (
            <div className="text-center py-4">
              <Spinner />
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

/* Status pill helper component */
function StatusPill({ status }) {
  const s = (status || "").toLowerCase().trim();

  if (s === "accepted" || s === "accept" || s === "approved") {
    return (
      <span style={{ ...styles.pillBase, ...styles.pillAccepted }}>
        Accepted
      </span>
    );
  }

  if (s === "rejected" || s === "reject" || s === "declined") {
    return (
      <span style={{ ...styles.pillBase, ...styles.pillRejected }}>
        Rejected
      </span>
    );
  }

  return (
    <span style={{ ...styles.pillBase, ...styles.pillPending }}>Pending</span>
  );
}
